import Store from '@mjcloud/redux';
import Reduce from './reduce';
import ChartExtendStore from './extendStore';
import { DataInstanceBase } from '@mjcloud/instance';
import { DataModeEnum } from '@mjcloud/types';
import { IChartState } from './typings';

export default class Chart extends DataInstanceBase<IChartState> {
  chart: any;
  __createStore() {
    return new Store<IChartState>({
      id: this.id,
      reduce: Reduce,
      extendStore: new ChartExtendStore(this),
    });
  }

  getDataMode() {
    if (this.store.state.pageSize) return DataModeEnum.pagination;
    return DataModeEnum.all;
  }

  initialState(initConfig) {
    this.store.dispatch('configStartLoad', {
      initConfig,
    });
  }
}
